import styles from "./ValidatedInput.module.scss";
import Typography from "../Typography/Typography";
import TextInput from "../TextInput/TextInput";

const ValidatedInput = (props) => {
	const {
		type,
		onChange = () => {},
		className,
		placeholder,
		label,
		disabled = false,
		error = false,
		setError,
		errorMessage = "",
		pattern,
		formatter,
		...rest
	} = props;

	const errorMjs = errorMessage || "Campo inválido";

	return (
		<div className={`${styles.validatedInputContainer} ${className}`}>
			<TextInput
				{...rest}
				type={type}
				onChange={onChange}
				placeholder={placeholder}
				label={label}
				error={error}
				setError={setError}
				pattern={pattern}
				formatter={formatter}
				disabled={disabled}
			></TextInput>

			<Typography
				className={styles.validatedInputErrorMjs}
				color={error ? "red" : "transparent"}
				variant="p3"
			>
				{errorMjs}
			</Typography>
		</div>
	);
};

export default ValidatedInput;
